export * from './field';

/** Input */
// Inspiration from FieldRenderProps - react-final-form
interface FieldMetaState {
  active?: boolean;
  dirty?: boolean;
  dirtySinceLastSubmit?: boolean;
  error?: any;
  initial?: any;
  invalid?: boolean;
  length?: number;
  modified?: boolean;
  pristine?: boolean;
  submitError?: any;
  submitFailed?: boolean;
  submitSucceeded?: boolean;
  submitting?: boolean;
  touched?: boolean;
  valid?: boolean;
  visited?: boolean;
}
export interface FieldInputProps<T extends HTMLElement> {
  name: string;
  onBlur?: (event?: React.FocusEvent<T>) => void;
  onChange?: (event: React.ChangeEvent<T> | any) => void;
  onFocus?: (event?: React.FocusEvent<T>) => void;
  type?: string;
  value?: any;
  checked?: boolean;
  multiple?: boolean;
}
export interface FieldRenderProps<T extends HTMLElement> {
  input: FieldInputProps<T>;
  meta: FieldMetaState;
}
export interface IOption {
  name: string;
  value: string;
}

/** Pills */
export interface IPill {
  id?: string;
  color: FullThemeStyle;
  name: string;
}

/** Record Ref */
export interface IForeignRow {
  id: string;
  table: Array<{ id: string; core: Array<{ id: string; workspace: Array<{ id: string }> }> }>;
  visibleName?: string;
}

/** Theme */
export enum ThemeStyle {
  black = 'black',
  gray = 'gray',
  blue = 'blue',
  red = 'red',
  white = 'white',
}

export enum FullThemeStyle {
  blue = 'blue',
  cyan = 'cyan',
  teal = 'teal',
  green = 'green',
  yellow = 'yellow',
  orange = 'orange',
  red = 'red',
  pink = 'pink',
  purple = 'purple',
  gray = 'gray',
  white = 'white',
}

/** Typography */
export enum TypographyStyle {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  P1 = 'P1',
  P2 = 'P2',
  LABEL1 = 'LABEL1',
  LABEL2 = 'LABEL2',
}
export enum TypographyWeight {
  Light = 'Light',
  Regular = 'Regular',
  Medium = 'Medium',
  Bold = 'Bold',
}
